"use strict";
exports.__esModule = true;
exports.parseUnits = exports.isAValidUnits = void 0;
/**
 * Method that checks if an unit is valid
 * @param {string} inputUnit
 * @returns {boolean}
 */
var isAValidUnits = function (inputUnit) {
    if (/^-?\d+\.?\d*$/.test(inputUnit)) {
        if (Number(inputUnit) <= -1 || Number(inputUnit) >= 1) {
            return true;
        }
    }
    return false;
};
exports.isAValidUnits = isAValidUnits;
/**
 * Method that transform units a valid form
 * @param {number} inputUnit
 * @returns {number}
 */
var parseUnits = function (inputUnit) {
    if (inputUnit < 0) {
        inputUnit *= -1;
    }
    return Math.floor(inputUnit);
};
exports.parseUnits = parseUnits;
//# sourceMappingURL=transaction-charge.utils.js.map